export const categories = {
  mechanical: {
    key: 'mechanical',
    label: 'Mechanical',
  },
  electrical: {
    key: 'electrical',
    label: 'Electrical',
  },
  infrastructure: {
    key: 'infrastructure',
    label: 'Infrastructure',
  },
  other: {
    key: 'other',
    label: 'Other',
  },
};

export const categoriesList = Object.values(categories);

export enum CriticalityLevel {
  High = 1,
  Medium = 2,
  Low = 3,
}

export const criticalityLevels = {
  [CriticalityLevel.High]: {
    value: CriticalityLevel.High,
    key: 'high',
    label: 'High',
  },
  [CriticalityLevel.Medium]: {
    value: CriticalityLevel.Medium,
    key: 'medium',
    label: 'Medium',
  },
  [CriticalityLevel.Low]: {
    value: CriticalityLevel.Low,
    key: 'low',
    label: 'Low',
  },
};

export const criticalityLevelsList = Object.values(criticalityLevels);

export const inUseStatuses = {
  newlyCreated: {
    key: 'newlyCreated',
    label: 'Newly created',
  },
  inUse: {
    key: 'inUse',
    label: 'In-use',
  },
  deprecated: {
    key: 'deprecated',
    label: 'Deprecated',
  },
};

export const inUseStatusesList = Object.values(inUseStatuses);
